const CustomInputLabel = ({ text, isRequired = false }) => {
  return (
    <label className="mb-2 text-sm font-medium text-gray-600">
      {text} {isRequired && <span className="font-bold">*</span>}
    </label>
  );
};

export default CustomInputLabel;
